/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { storageFor } from 'ember-local-storage';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import AssetModel, { AssetsQueryParams, ASSETS_DEFAULT_SORT_BY, ASSETS_DEFAULT_ASC } from 'cio/models/asset';

interface AssetLibraryModalArgs {
  builderType: string;
  onClose: () => unknown;
  onSelectAsset: (imagePath: string) => unknown;
  filterFileSizeInBytes?: number;
  filterPdfs?: boolean;
}

const LOCAL_STORAGE_KEY_PREFIX = 'asset-library-modal-last-params';

export default class AssetLibraryModal extends Component<AssetLibraryModalArgs> {
  @service environment!: EnvironmentService;

  @tracked folderId!: string | null;
  @tracked page!: number;
  @tracked sort!: string;
  @tracked asc!: boolean;
  @tracked search!: string;
  @tracked isUploading = false;
  @tracked showConfirmCloseWhileUploadingModal = false;

  @storageFor('cio-asset-library') localStorage: any;
  readonly localStorageKey = `${LOCAL_STORAGE_KEY_PREFIX}-${this.environment.current.id}`;

  constructor(owner: unknown, args: AssetLibraryModalArgs) {
    super(owner, args);

    let params = this.localStorage.get(this.localStorageKey);
    this.folderId = params?.folderId ?? null;
    this.page = params?.page ?? 1;
    this.sort = params?.sortBy ?? ASSETS_DEFAULT_SORT_BY;
    this.asc = params?.sortAsc ?? ASSETS_DEFAULT_ASC;
    this.search = params?.search ?? '';
  }

  @action
  onSelectAsset(asset: AssetModel) {
    this.args.onSelectAsset(asset.path);
  }

  @action
  onParamsChange(params: AssetsQueryParams) {
    let { folderId, page, sortBy, sortAsc, search } = params;

    // avoid issue where folderId is updated after being used in previous computation
    if (this.folderId !== folderId) {
      this.folderId = folderId;
    }

    this.page = page;
    this.sort = sortBy;
    this.asc = sortAsc;
    this.search = search;

    this.localStorage.set(this.localStorageKey, params);
  }

  @action
  onFileUploadStarted() {
    this.isUploading = true;
  }

  @action
  onAllFilesUploadFinished() {
    this.isUploading = false;
  }

  @action
  onAssetLibraryModalClose() {
    if (this.isUploading) {
      this.showConfirmCloseWhileUploadingModal = true;
    } else {
      this.args.onClose();
    }
  }

  @action
  onConfirmCloseAssetLibraryModal() {
    this.showConfirmCloseWhileUploadingModal = false;
    this.args.onClose();
  }
}
